// src/components/StatusView/StatusView.jsx
import React from 'react';
import './StatusView.less';
import ElipsisLoader from '../Loaders/ElipsisLoader';
import { usePreparingNotification } from '../../hooks/usePreparingNotification';
import { STATUS_KEYS as STATUS } from '../../constants/statusKeys';
import { STATUS_MAP } from '../../constants/statusMap';

const FALLBACK = STATUS.UNKNOWN;

const StatusView = ({ status }) => {
  const safeKey = STATUS_MAP[status] ? status : FALLBACK;
  const config = STATUS_MAP[safeKey];

  const {
    iconComponent: Icon,
    iconProps,
    image,
    title,
    subtitle,
    showLoader
  } = config;

  const { isPreparing } = usePreparingNotification({
    enabled: safeKey === STATUS.PLUG_IN,
    onPreparing: () => {},
    showNotification: false,
  });

  return (
    <div className="status-view">
      
      {/* Icon or Image */}
      <div className="status-icon-wrapper">
        {image ? (
          <img src={image} alt="" className="status-illustration flash" />
        ) : (
          Icon && <Icon {...iconProps} />
        )}
      </div>

      {/* Title */}
      <div className="status-title">{title}</div>

      {/* Optional subtext */}
      {subtitle && <div className="status-subtext">{subtitle}</div>}

      {/* Preparing state */}
      {safeKey === STATUS.PLUG_IN && isPreparing && (
        <div className="status-preparing">
          <ElipsisLoader />
          <div className="status-preparing-text">Preparing charger…</div>
        </div>
      )}

      {/* Generic loader */}
      {showLoader && safeKey !== STATUS.PLUG_IN && (
        <div className="status-generic-loader">
          <ElipsisLoader />
        </div>
      )}
    </div>
  );
};

export default StatusView;
